// extracted by mini-css-extract-plugin
module.exports = {"section--create--single":"section--create--single__2O6fo","section--create--multiple":"section--create--multiple__1EQGw"};